import React from 'react'
import { Button, Layout } from 'antd'
import { BellOutlined, QuestionCircleOutlined, SettingOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import HeaderBreadcrumb from './Header/HeaderBreadcrumb'
import HeaderSearch from './Header/HeaderSearch'
import AppSwitcher from './Header/AppSwitcher'
import UserMenu from './Header/UserMenu'

const Header: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Layout.Header className="gt-app-header">
      <HeaderBreadcrumb />
      <div className="gt-app-header-spacer" />
      <HeaderSearch />
      <Button
        type="text"
        className="gt-header-icon-btn gt-header-icon-btn-badge"
        icon={<BellOutlined />}
        aria-label="Notifications"
        onClick={() => navigate('/notifications')}
      />
      <Button
        type="text"
        className="gt-header-icon-btn"
        icon={<QuestionCircleOutlined />}
        aria-label="Help"
        onClick={() => navigate('/help')}
      />
      <AppSwitcher />
      <Button
        type="text"
        className="gt-header-icon-btn"
        icon={<SettingOutlined />}
        aria-label="Settings"
        onClick={() => navigate('/settings')}
      />
      <UserMenu />
    </Layout.Header>
  )
}

export default Header
